import { commonRequest } from '../../../../services/ApiCall';
import { Helpers } from '../../../../services/Helpers';

const adminBaseUrl = () => `${Helpers.URL()}/api/admin/manage-customer-app/fonts`;

export const GlobalFontServices = {
    list: async ({ includeInactive = true, search = '' } = {}) => {
        const params = new URLSearchParams({
            includeInactive: String(includeInactive),
            ...(search ? { search } : {})
        });
        return commonRequest('GET', `${adminBaseUrl()}?${params.toString()}`, {}, Helpers.token());
    },
    listActive: async () => {
        const params = new URLSearchParams({ includeInactive: 'false' });
        return commonRequest('GET', `${adminBaseUrl()}?${params.toString()}`, {}, Helpers.token());
    },
    upload: async ({ name, file }, onProgress) => {
        const formData = new FormData();
        formData.append('name', name || '');
        formData.append('file', file);
        return commonRequest('POST', adminBaseUrl(), formData, Helpers.token(), onProgress);
    },
    update: async (id, data) => {
        return commonRequest('PUT', `${adminBaseUrl()}/${id}`, data, Helpers.token());
    },
    remove: async (id) => {
        return commonRequest('DELETE', `${adminBaseUrl()}/${id}`, {}, Helpers.token());
    }
};
